export default __webpack_public_path__ + "static/media/quill-ink.87fa681c.png";